import gsap from 'gsap';

const open = gsap.timeline({ paused: true });

open
    .to('.collapse', { opacity: 1, ease: 'easeInOut', display: 'block', visibility: 'visible', duration: 0.4 })
    .to('.collapse .animated-menu-item', { opacity: 1, x: 0, stagger: 0.1, ease: 'easeInOut', duration: 0.4 }, '-=0.2')
    .to('.collapse__close .collapse-toggler', { opacity: 1,ease: 'easeInOut', duration: 0.2}, '-=0.2')
    .to('.collapse__content__info__contact', { opacity: 1, y: 0, ease: 'easeInOut', duration: 0.2}, '-=0.2')
;

const close = gsap.timeline({ 
    paused: true,
    clearProps: true,
});

close
    .to('.collapse', { opacity: 0, ease: 'easeInOut', display: 'none', visibility: 'hidden', duration: 0.4 })
;

/**
 * Toggle different timeline animations
 *
 * @param {object} timeline
 */
const toggleTimeline = (timeline) => {
    if (timeline.progress() === 0) {
        timeline.play();
    } else {
        timeline.restart();
    }
}

const menuScroll = (open) => {
    if(window.innerWidth > 767) {
        if(open) {
            console.log('visable');
            window.scroll_position = $(window).scrollTop();
            $('body')
                .css('position', 'fixed')
                .css('overflow', 'hidden')
                .css('width', '100%');
        } else {
            console.log('not visable');
            $('body')
                .css('position', '')
                .css('overflow', '')
                .css('width', 'auto');
            $(window).scrollTop(window.scroll_position);
        }
    }
}

/**
 * Toggle function that trigger an timeline animation
 */
$('.collapse-toggler').on('click', function() {
    if( $('.collapse').is(":visible") ) {
        toggleTimeline(close);
        menuScroll(false);
    } else {
        toggleTimeline(open);
        menuScroll(true);
    }
});

/**
 * Close menu when escape is pressed
 */
$(document).keydown(function(event) {
    if (event.keyCode == 27) {
        if( $('.collapse').is(":visible") ) {
            toggleTimeline(close);
            menuScroll(false);
        }
    }
});


$(document).on('click', '[data-modal="offerte"]', function () {
    if( $('.collapse').is(":visible") ) {
        toggleTimeline(close);
        menuScroll(false);
    }
});
